/*Hover Central Menu*/
$('.header_center .menus_wrapper .eshop_menu').mouseenter(function(event) {
      $('.menus_wrapper').removeClass('left');
      $('.menus_wrapper').addClass('right');
      $('.hover_button').removeClass('left');
      $('.hover_button').addClass('right');
 });

 $('.header_center .menus_wrapper .site_menu').mouseenter(function(event) {
       $('.menus_wrapper').removeClass('right');
       $('.menus_wrapper').addClass('left');
       $('.hover_button').removeClass('right');
       $('.hover_button').addClass('left');
  });

  $('section').mouseenter(function(event) {
        $('.menus_wrapper').removeClass('right');
        $('.menus_wrapper').addClass('left');
        $('.hover_button').removeClass('right');
        $('.hover_button').addClass('left');
   });

/*Open Mobile Menu*/
   $(".mobile_header .open_menu").on('click', function () {
     if ($(this).hasClass('is-active')) {
       $(this).removeClass('is-active');
       $('.mobile_menu').removeClass('is-active');
       $('.overlay').removeClass('is-active');
       //
       // $( ".mobile_menu .menu > ul > li" ).each(function( index ) {
       //     if(index==0){
       //         $(this).css({ transition : 'opacity 0s ease-in-out' });
       //     }else{
       //       $(this).css({ transition : 'opacity 0s '+ index * 0 +'s ease-in-out' });
       //     }
       // });
     }
     else {
       $(this).addClass('is-active');
       $('.mobile_menu').addClass('is-active');
       $('.overlay').addClass('is-active');

       // $( ".mobile_menu .menu > ul > li" ).each(function( index ) {
       //     if(index==0){
       //         $(this).css({ transition : 'opacity 0.3s ease-in-out,transform 0.5s 0.2s ease-in-out' });
       //     }else{
       //       $(this).css({ transition : 'opacity 0.3s '+ index * 0.3 +'s ease-in-out,transform 0.5s '+ index * 0.3 +'s ease-in-out' });
       //     }
       // });

     }
   });

   $(".submenu_wrapper ul li a").on('click', function () {
      $('.close_shop_menu').addClass('is-nonactive');
      return true;
   });

   $(".shop_menu a").on('click', function () {
     if($(this).parent().hasClass('has-sub') || $(this).parent().hasClass('shop_menu')){
       if ($(this).parent().hasClass('is-active')) {
         $(this).parent().removeClass('is-active');
       }
       else {
        if($(this).parent().hasClass('has-sub')){
          $('.close_shop_menu').addClass('is-nonactive');
        }else{
          $('.close_shop_menu').removeClass('is-nonactive');
        }
        $(".submenu_wrapper").removeClass('is-nonactive');
         $(this).parent().addClass('is-active');
       }
       return false;
     }else{

     }
   });


   $(".submenu_wrapper span").on('click', function () {
     if ($(this).parent().hasClass('is-nonactive')) {
       $(this).parent().removeClass('is-nonactive');
     }
     else {
       $(this).parent().addClass('is-nonactive');
       $(this).parent().parent().removeClass('is-active');
       $('.close_shop_menu').removeClass('is-nonactive');
     }
     return false;
   });


   $(".close_shop_menu").on('click', function () {
      $(this).parent().removeClass('is-active');
     return false;
   });


/*Open Search*/
$(".header_wrapper .header_right .site_info .search a").on('click', function () {
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $('.product_search').removeClass('is-active');
    $('.overlay').removeClass('is-active');
  }
  else {
    $(this).addClass('is-active');
    $('.product_search').addClass('is-active');
    $('.overlay').addClass('is-active');
  }
  return false;
});

/*Open Search*/
$(".mobile_header .header_right .search a").on('click', function () {
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $('.product_search').removeClass('is-active');
    $('.overlay').removeClass('is-active');
  }
  else {
    $(this).addClass('is-active');
    $('.product_search').addClass('is-active');
    $('.overlay').addClass('is-active');
  }
  return false;
});

/*Close Search*/
$(".closebutton").on('click', function () {
    $('.header_wrapper .header_right .site_info .search a').removeClass('is-active');
    $('.product_search').removeClass('is-active');
    $('.overlay').removeClass('is-active');
    return false;
});

/*Open Menu*/
$(".site_menu").on('click', function () {
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $('#headermenu').removeClass('is-active');
    $('.overlay').removeClass('is-active');
  }
  else {
    $(this).addClass('is-active');
    $('#headermenu').addClass('is-active');
    $('.overlay').addClass('is-active');
  }
});

/*Open Shop Menu*/
$(".eshop_menu").on('click', function () {
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $('.line').removeClass('is-active');
    $('#shopmenu').removeClass('is-active');
    $('.overlay').removeClass('is-active');
  }
  else {
    $(this).addClass('is-active');
    $('#shopmenu').addClass('is-active');
    $('.overlay').addClass('is-active');
    $('.line').addClass('is-active');
  }
});

$("#menu-shop-menu li a").on('click', function (e) {

  $('.sub-menu').removeClass('fir-sub');
  $('.sub-menu').removeClass('sec-sub');
  $("#menu-shop-menu li").removeClass('active-link');

    if($(this).parent().hasClass('menu-item-has-children')){
        $(this).parent().addClass('active-link');
        $(this).parent().find('.sub-menu').addClass('fir-sub');
        if($(this).parent().find('.sub-menu').find('.menu-item-has-children').find('.sub-menu')){
          $(this).parent().find('.sub-menu').find('.menu-item-has-children').find('.sub-menu').addClass('sec-sub');
        }
        e.preventDefault();
        return false;
    }
});

/*Open Mini Cart*/
$(".mini-cart-open-btn").on('click', function () {
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $('.mini-cart-widget-outer-wrapper').removeClass('is-active');
  }
  else {
    $(this).addClass('is-active');
    $('.mini-cart-widget-outer-wrapper').addClass('is-active');
  }
  return false;
});

/*Custom Tabs*/
$("#custom_tabs .tabs p").on('click', function () {
  var tab_open;
  var content_open;
  if($(this).hasClass('active')){

  }else{
    $("#custom_tabs .tabs p").removeClass('active');
    $(this).addClass('active');
    tab_open=$(this).attr("data-tab");
  }
  $( ".tab_content .content" ).each(function( index ) {
      content_open=$(this).attr("data-tab");
      if(content_open == tab_open){
        $( ".tab_content .content" ).removeClass('active');
        $(this).addClass('active');
      }
  });

});



$(document).ready(function () {
  setTimeout(function () {
    $('h1').addClass('is-visible');
  }, 200);
});

import Swiper, { Navigation } from 'swiper';
/* Featured home swipper */
if($(".home #featured").length || $('.single-product #related').length){
    new Swiper(".featured_swipe", {
        slidesPerView: 1.5,
        grabCursor: true,
        direction: 'horizontal',
        speed: 1200,
        navigation: {
            nextEl: ".arrows .next",
            prevEl: ".arrows .prev",
        },
        spaceBetween: 15,
        breakpoints: {
            1440: {
                slidesPerView: 3.5,
                spaceBetween: 70
            },
            991: {
                slidesPerView: 2.5,
                spaceBetween: 40
              },
            0: {
                  slidesPerView: 1,
                  spaceBetween: 0,
              }
          }
    });


};

if($(".single-product").length ){
    new Swiper(".product_image_swipe", {
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
            nextEl: ".arrows .next",
            prevEl: ".arrows .prev",
        },
    });
};


$(document).ready(function () {
  if($('body').hasClass('page-template-tmpl_contact')){

  $(".contact_form input").on('click', function () {
      if($(this).parent().parent().hasClass('active')){
        $('.contact_form label').removeClass('active');
        $(this).parent().parent().removeClass('active');
      }else{
        $('.contact_form label').removeClass('active');
        $(this).parent().parent().addClass('active');
      }
    });

    $(".contact_form textarea").on('click', function () {
        if($(this).parent().parent().hasClass('active')){
          $('.contact_form label').removeClass('active');
          $(this).parent().parent().removeClass('active');
        }else{
          $('.contact_form label').removeClass('active');
          $(this).parent().parent().addClass('active');
        }
      });

  }

});


// Wrap every letter in a span
// var textWrapper = document.querySelector('.text p');
// textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letters'>$&</span>");

// var words = $("#about .text p").text().split(" ");
//
// $("#about .text p").empty();
// $.each(words, function(i, v) {
//     $("#about .text p").append($("<span class='letters'>").text(v));
// });
$(document).ready(function () {
  if($('body').hasClass('home')){
    const p = document.querySelector('#about .text p');
    splitParagraph(p);
    var flagflag=1;
    function splitParagraph(p) {
      // Get the text content of the paragraph and split it into words
      const words = p.innerHTML.trim().split(/\s+/);
      // Clear the paragraph's contents
      p.innerHTML = '';

      // Loop through each word and add a span element with the class letter to each word
      words.forEach(word => {
        const span = document.createElement('span');
        span.classList.add('letters');
        if (word.includes('<strong>')) {
          span.classList.add('bold');
          flagflag=0;
          word = word.replace(/<strong>|<\/strong>/g, '');
        }
        if(word.includes('</strong>')){
          span.classList.add('bold');
          word = word.replace(/<strong>|<\/strong>/g, '');
          flagflag=1;
        }
        if(flagflag==0){
          span.classList.add('bold');
        }
        span.textContent = word;
        p.appendChild(span);
        p.appendChild(document.createTextNode(' '));
      });
    }
  }
});
